// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDYBjj0zEreBh3K6Msaox1tZeY8sR6nsIo",
  authDomain: "item-request-app.firebaseapp.com",
  projectId: "item-request-app",
  storageBucket: "item-request-app.firebasestorage.app",
  messagingSenderId: "580792456877",
  appId: "1:580792456877:web:6852130c4861ea8ea91824",
  measurementId: "G-HL47X0EBDN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);